/** 필수 표시(*) 색 — antd 기본 에러색. ST02 사유 모달과 같은 값이다. */
export const REQUIRED_MARK_COLOR = '#ff4d4f'

/** 그리드가 비었을 때 엑셀 다운로드를 막는 안내. 클라이언트 생성(Excel.download) 시절 문구를 그대로 쓴다. */
export const EXCEL_NO_DATA_MESSAGE = '다운로드 할 데이터가 없습니다. 검색 후 다운로드 해주세요.'
